import useAxios from "axios-hooks";
import { useEffect, useState } from "react";
import AutocompleteInput from "../../components/input/AutoCompleteInput";
import { XMarkIcon } from "@heroicons/react/24/outline";
import PaginationButtons from "../../components/pagination/PaginationButtons";
import { cp } from "fs";

export default function TransferList(props: {
  isOpen: boolean;
  onFinish: any;
  currentContentIds?: number[];
  url: string;
}) {
  const [searchString, setSearchString] = useState("");
  const [selectedContents, setSelectedContents] = useState([] as any[]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [{ data, loading, error }, fetchContents] = useAxios({
    url: props.url,
    params: {
      page,
      search: searchString,
      excludeIds: props.currentContentIds,
    },
  });

  const checkboxHandler = (content: any) => {
    let currentSelected = [...selectedContents];

    let existingIndex = currentSelected.findIndex((t) => t._id === content._id);

    if (existingIndex === -1) {
      currentSelected.push(content);
    } else {
      currentSelected.splice(existingIndex, 1);
    }

    setSelectedContents(currentSelected);
  };

  const removeHandler = (contentId: number) => {
    let currentSelected = [...selectedContents];

    let existingIndex = currentSelected.findIndex((t) => t._id === contentId);

    if (existingIndex !== -1) {
      currentSelected.splice(existingIndex, 1);
    }

    setSelectedContents(currentSelected);
  };

  useEffect(() => {
    if (props.isOpen && !data && !loading) {
      fetchContents();
    }
  }, [loading, data, props.isOpen, selectedContents]);

  if (loading && !data) return <div>Loading...</div>;
  if (!props.isOpen) return <></>;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex justify-between">
        <div className="w-1/2 h-8">
          <AutocompleteInput
            onComplete={(input: string) => {
              setPage(1);
              setSearchString(input);
            }}
            placeHolder="Search..."
          />
        </div>
        <form method="dialog">
          <button className="btn btn-outline btn-xs btn-circle">
            <XMarkIcon className="w-full h-full" />
          </button>
        </form>
      </div>

      <div className="flex gap-2 pt-4 h-[calc(90vh-1rem-10rem)]">
        {/* Available Content List */}
        <div className="w-1/2 bg-base-200 rounded-lg overflow-y-auto">
          <table className="table table-md w-full rounded-lg">
            <thead className="text-base-content sticky top-0 z-10 bg-base-200">
              <tr>
                <th className="text-sm w-[20%]">Name</th>
                <th className="text-sm w-[40%]">Description</th>
                <th className="text-sm text-center">Difficulty</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data?.docs?.map((content: any) => (
                <tr
                  key={content?._id}
                  className="hover:bg-base-300 transition cursor-pointer"
                >
                  <td className="font-medium">{content?.name}</td>
                  <td>
                    {content?.info?.description?.about?.substring(0, 100)}...
                  </td>
                  <td className="text-center">{content?.info?.difficulty}</td>
                  <td>
                    <label>
                      <input
                        checked={selectedContents.some(
                          (c: any) => c._id === content._id
                        )}
                        onChange={() => {}}
                        onClick={() => checkboxHandler(content)}
                        type="checkbox"
                        className="checkbox"
                      />
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Selected Content List */}
        <div className="w-1/2 bg-base-200 rounded-lg overflow-y-auto">
          <table className="table table-md w-full rounded-lg">
            <thead className="text-base-content sticky top-0 z-10 bg-base-200">
              <tr>
                <th className="text-sm w-[20%]">Name</th>
                <th className="text-sm w-[40%]">Description</th>
                <th className="text-sm text-center">Difficulty</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {selectedContents.map((content: any) => (
                <tr
                  key={content?._id}
                  className="hover:bg-base-300 transition cursor-pointer"
                >
                  <td className="font-medium">{content?.name}</td>
                  <td>
                    {content?.info?.description?.about?.substring(0, 100)}...
                  </td>
                  <td className="text-center">{content?.info?.difficulty}</td>
                  <td>
                    <button
                      onClick={() => removeHandler(content._id)}
                      className="btn btn-xs btn-error"
                    >
                      <XMarkIcon className="h-5 w-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <PaginationButtons
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        pageCount={data?.meta?.pagination?.pageCount}
      />

      <button
        onClick={() => props.onFinish(selectedContents.map((c: any) => c._id))}
        className="btn btn-sm btn-primary ml-auto"
      >
        Finish
      </button>
    </div>
  );
}
